import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import TextInput from '../../inputFields/TextInput';
import CustomIconButton from '../../inputFields/CustomIconButton';
import httpRequest from '../../../../HttpService';

const ContactForm = props => {
    const [nameValue, setNameValue] = useState('');
    const [phoneValue, setPhoneValue] = useState('');

    useEffect(() => {
        setNameValue(props.data.contactName || '');
        setPhoneValue(props.data.contactPhone || '');
    }, [props.data]);

    const saveField = (field, value) => {
        const currentValue = props.data[field] || '';
        if (currentValue === value && field !== null) {
             return;
        }

        // Build the payload from props, not from local state, to avoid race conditions.
        const updatedContactDetails = {
            ...props.data,
            contactName: field === 'contactName' ? value : props.data.contactName || '',
            contactPhone: field === 'contactPhone' ? value : props.data.contactPhone || '',
        };

        if (!updatedContactDetails.contactName && !updatedContactDetails.contactPhone) {
            updatedContactDetails.contactID = null;
        }

        httpRequest.addContact(props.accountNumber, updatedContactDetails)
            .then(contactRes => {
                const newContactID = (contactRes.data && contactRes.data[0]) ? contactRes.data[0].contactID : null;
                httpRequest.updateAddressContact(props.accountNumber, props.data.addressID, newContactID)
                    .then(updateRes => {
                        httpRequest.getAddressByID(props.accountNumber, props.data.addressID).then(data => {
                            if (props.onContactUpdate) {
                                // Send the fresh, confirmed data back up the chain.
                                props.onContactUpdate(data.data[0]);
                            }
                        });
                    }).catch(error => console.error(`ERROR in updateAddressContact:`, error));
            }).catch(error => console.error(`ERROR in addContact:`, error));
    };

    return (
        <Grid container style={{paddingBottom: '2%'}} key='contact-form'>
            <p>CONTACT DETAILS</p>
            <Grid container spacing={1}>
                <Grid item sm={6} xs={12} key='contact-form-name'>
                   <Grid container alignItems="center" spacing={1}>
                        <Grid item xs={10}>
                            <TextInput 
                                name="contactName"
                                type="text"
                                label="Name"
                                labelSize={5}
                                variant="outlined" 
                                size="small" 
                                value={nameValue}
                                onChange={(e) => setNameValue(e.target.value)}
                                onBlur={(e) => saveField('contactName', e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <div onMouseDown={(e) => e.preventDefault()}>
                                <CustomIconButton 
                                    icon="CloseSharpIcon" 
                                    tooltip="Clear Name" 
                                    onClick={() => {
                                        setNameValue(''); 
                                        saveField('contactName', '');
                                    }} 
                                    variant="outlined" 
                                    color="primary" 
                                />
                            </div>
                        </Grid>
                   </Grid>
                </Grid>
                <Grid item sm={6} xs={12} key='contact-form-phone'>
                    <Grid container alignItems="center" spacing={1}>
                        <Grid item xs={10}>
                            <TextInput 
                                name="contactPhone"
                                type="tel"
                                label="Phone"
                                labelSize={5}
                                variant="outlined" 
                                size="small"
                                placeholder="123-456-7890"
                                value={phoneValue}
                                onChange={(e) => setPhoneValue(e.target.value)}
                                onBlur={(e) => saveField('contactPhone', e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <div onMouseDown={(e) => e.preventDefault()}>
                                <CustomIconButton 
                                    icon="CloseSharpIcon" 
                                    tooltip="Clear Phone" 
                                    onClick={() => {
                                        setPhoneValue('');
                                        saveField('contactPhone', '');
                                    }} 
                                    variant="outlined" 
                                    color="primary" 
                                />
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ContactForm;